import { render, staticRenderFns } from "./ProjectAlgorithmsPage.vue?vue&type=template&id=40c24737&scoped=true&"
import script from "./ProjectAlgorithmsPage.vue?vue&type=script&lang=js&"
export * from "./ProjectAlgorithmsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAlgorithmsPage.vue?vue&type=style&index=0&id=40c24737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c24737",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
